<template>
  <router-view @open-drawer="$emit('open-drawer')"></router-view>
</template>

<script>
export default {};
</script>

<style></style>
